import Vue from 'vue';
import Vuex from 'vuex';
import state from './state';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';

import address from './address/index';
import { order, preOrderParamsPersistField, preOrderParamsSessionFieId } from './order/index';

import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
  modules: {
    address,
    order
  },
  plugins: [
    createPersistedState({
      key: 'vuex-zyyd',
      paths: [...preOrderParamsPersistField.map(field => `order.${field}`)]
    }),
    createPersistedState({
      storage: window.sessionStorage,
      paths: [...preOrderParamsSessionFieId.map(field => `order.${field}`)]
    })
  ]
});
